module.exports = __webpack_public_path__ + "img/10551383_L.5aba7d1d.png";